/* =========================================================================
   SECTION: MIX & MATCH BUILDER (Master State Controller)
   ========================================================================= */
document.addEventListener('DOMContentLoaded', function () {
  var sectionEl = document.querySelector('.js-atelier-section');
  if (!sectionEl) return;

  var isMobile = window.matchMedia('(max-width: 989px)');

  // 1. Sticky Header Gap Calculation
  var siteHeader = document.querySelector('sticky-header') || document.querySelector('header');
  function updateStickyGap() {
    if (!siteHeader || isMobile.matches) return; 
    var rect = siteHeader.getBoundingClientRect();
    var visibleBottom = Math.max(0, rect.bottom);
    sectionEl.style.setProperty('--atelier-header-gap', visibleBottom + 'px');
  }
  if (siteHeader) {
    window.addEventListener('scroll', updateStickyGap, { passive: true });
    window.addEventListener('resize', updateStickyGap, { passive: true });
    updateStickyGap();
  }

  // 2. Core State
  window.AtelierBuilderState = {
    targetQty: parseInt(sectionEl.dataset.initialQty, 10),
    activeVariantId: sectionEl.dataset.initialVariant,
    selection: {},
    totalSelected: 0
  };

  // Helper: Build the cart properties object
  function buildCart() {
    var state = window.AtelierBuilderState;
    var props = { '_Box size': state.targetQty + ' chocolates' };
    
    Object.keys(state.selection).forEach(function (id) {
      if (state.selection[id] > 0) {
        var wrap = document.querySelector('.atelier-card[data-variant-id="' + id + '"]');
        var name = wrap ? wrap.dataset.productTitle : id;
        props[name] = '\u00d7' + state.selection[id];
      }
    });
    return props;
  }

  // 3. Global API for Widgets to call
  window.AtelierBuilder = {
    add: function(variantId) {
      var state = window.AtelierBuilderState;
      state.selection[variantId] = (state.selection[variantId] || 0) + 1;
      state.totalSelected++;
      updateGlobalUI();
    },
    minus: function(variantId) {
      var state = window.AtelierBuilderState;
      if ((state.selection[variantId] || 0) <= 0) return;
      state.selection[variantId]--;
      state.totalSelected--;
      updateGlobalUI();
    },
    remove: function(variantId) {
      var state = window.AtelierBuilderState;
      state.totalSelected -= (state.selection[variantId] || 0);
      state.selection[variantId] = 0;
      updateGlobalUI();
    },
    submit: async function(btn, errEl) {
      if (errEl) { 
        errEl.classList.remove('is-visible'); 
        errEl.textContent = ''; 
      }
      
      btn.classList.add('is-loading');
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding\u2026';

      try {
        var res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ 
            id: window.AtelierBuilderState.activeVariantId, 
            quantity: 1, 
            properties: buildCart() 
          })
        });
        
        if (!res.ok) throw new Error('Could not add to cart');
        window.location.href = window.Shopify.routes.root + 'cart';
      } catch (err) {
        if (errEl) { 
          errEl.textContent = 'Something went wrong. Please try again.'; 
          errEl.classList.add('is-visible'); 
        }
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }
  };

  // 4. Progress Bar UI
  var countEl = document.querySelector('.atelier-progress-count');
  var remainEl = document.querySelector('.atelier-progress-remaining');
  var fillEl = document.querySelector('.atelier-progress-bar__fill');
  
  function updateGlobalUI() {
    var state = window.AtelierBuilderState;
    var isOverfilled = state.totalSelected > state.targetQty;
    var rem = Math.max(state.targetQty - state.totalSelected, 0);

    if (countEl) countEl.textContent = state.totalSelected + ' of ' + state.targetQty + ' selected';

    // Update the visual progress bar width
    if (fillEl) {
      var percent = Math.min((state.totalSelected / state.targetQty) * 100, 100);
      fillEl.style.width = percent + '%';
      if (isOverfilled) {
        fillEl.classList.add('is-overfilled');
      } else {
        fillEl.classList.remove('is-overfilled');
      }
    }

    if (isOverfilled) {
      if (countEl) countEl.classList.add('is-overfilled');
      if (remainEl) remainEl.textContent = 'Too many selected';
    } else {
      if (countEl) countEl.classList.remove('is-overfilled');
      if (remainEl) remainEl.textContent = rem > 0 ? rem + ' remaining' : 'Box complete';
    }
    
    // Announce to the world (Pills, Widgets, Modals) that math has changed!
    document.dispatchEvent(new CustomEvent('AtelierBuilder:QtyChanged'));
  }

  // 5. Box Size Switching
  var sizesContainer = document.querySelector('.atelier-sizes');
  var priceEl = document.querySelector('.atelier-price');
  var mobilePriceEl = document.getElementById('AtelierMobilePrice');

  function formatPrice(formatted) {
    if (!formatted) return '';
    var parts = formatted.split('.');
    return parts.length === 2 ? parts[0] + '<span class="atelier-price__pence">.' + parts[1] + '</span>' : formatted;
  }

  if (sizesContainer) {
    sizesContainer.addEventListener('click', function(e) {
      var btn = e.target.closest('.atelier-size-btn');
      if (!btn) return;
      
      sizesContainer.querySelectorAll('.atelier-size-btn').forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      
      window.AtelierBuilderState.targetQty = parseInt(btn.dataset.quantity) || 12;
      window.AtelierBuilderState.activeVariantId = btn.dataset.variantId;
      
      var formatted = btn.dataset.priceFormatted;
      if (priceEl) priceEl.innerHTML = formatPrice(formatted);
      if (mobilePriceEl) mobilePriceEl.innerHTML = formatPrice(formatted);
      
      updateGlobalUI();
    });
  }

  // 6. Connect Primary CTA Buttons to the Global Submit API
  var addBtn = document.querySelector('.atelier-desktop-cta .atelier-add-btn');
  var mobileAddBtn = document.getElementById('AtelierMobileAddBtn');
  var errorEl = document.getElementById('AtelierError');
  var mobileError = document.getElementById('AtelierMobileError');

  if (addBtn) addBtn.addEventListener('click', function() { window.AtelierBuilder.submit(addBtn, errorEl); });
  if (mobileAddBtn) mobileAddBtn.addEventListener('click', function() { window.AtelierBuilder.submit(mobileAddBtn, mobileError); });

  // 7. Initialization Run
  var firstBtn = sizesContainer ? (sizesContainer.querySelector('.atelier-size-btn.is-active') || sizesContainer.querySelector('.atelier-size-btn')) : null;
  if (firstBtn) {
    window.AtelierBuilderState.targetQty = parseInt(firstBtn.dataset.quantity, 10) || 12;
    window.AtelierBuilderState.activeVariantId = firstBtn.dataset.variantId;
    if (priceEl) priceEl.innerHTML = formatPrice(firstBtn.dataset.priceFormatted);
    if (mobilePriceEl) mobilePriceEl.innerHTML = formatPrice(firstBtn.dataset.priceFormatted);
  }
  
  updateGlobalUI();
});